import React, { useState, useRef, useEffect } from "react";
import Button from "Components/Button";
import classnames from "classnames";
import PrimaryButton from "Components/Button/PrimaryButton";
import TextField from "Components/forms/text-field/TextField";
import Label from "Components/forms/label/Label";
import OutsideClickHandler from "Components/OutsideClickHandler";
import ConditionalIcon from "Components/icons/ConditionalIcon/ConditionalIcon";
import { getPopupTranslations } from "./configFilterStructure";
import PropTypes from "prop-types";
import "./ActivateStagePopUp.scss";

const ActiveStagePopUp = ({
  extraClass,
  isActivatBtnDisabled,
  toggleActivateStagePopup,
  onActivateStageSubmit
}) => {
  const inputRef = useRef();
  const [commentsValue, setCommentsValue] = useState("");
  const [length, setLength] = useState(0);
  const activateStageTranslations = getPopupTranslations();
  const wrapperClass = classnames("activate-stage-popup", {
    [extraClass]: extraClass,
  });

  const onCommentValueChange = (value) => {
    setLength(value.trim().length);
    setCommentsValue(value);
  };

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  return (
    <OutsideClickHandler onClickOutside={toggleActivateStagePopup}>
      <div className={wrapperClass}>
        <span>
          <h1 className="activate-stage-popup__header">
            <ConditionalIcon /> {activateStageTranslations.title}
          </h1>
        </span>
        <div className="activate-stage-popup__content">
          <label>{activateStageTranslations.confirmationMsg}</label>
          <TextField
            fieldClass="comment-text-field"
            htmlFor={activateStageTranslations.dataColumns[0].name}
            labelContent={activateStageTranslations.dataColumns[0].name}
            isRequired={activateStageTranslations.dataColumns[0].isRequired}
          >
            <textarea
              id="comment-box"
              ref={inputRef}
              maxLength={activateStageTranslations.dataColumns[0].textAreaMaxLength}
              style={{
                width: "259px",
                height: "74px",
                border: "1px solid #c4c4c4",
                backgroundColor: "#ffffff",
              }}
              onChange={(event) => onCommentValueChange(event.target.value)}
              value={commentsValue}
              disabled={isActivatBtnDisabled}
            />
          </TextField>
          <Label>
            <div className="message-text-char"> {length}/160 characters</div>
          </Label>
        </div>
        <div className="activate-stage-popup__footer">
          <Button extraClass="cancel-btn" action={toggleActivateStagePopup}>
            {activateStageTranslations.cancel}
          </Button>
          <PrimaryButton
            extraClass="activate-btn"
            disabled={isActivatBtnDisabled || length === 0}
            action={() => onActivateStageSubmit(commentsValue)}
          >
            {activateStageTranslations.activate}
          </PrimaryButton>
        </div>
      </div>
    </OutsideClickHandler>
  );
};

ActiveStagePopUp.propTypes = {
  extraClass: PropTypes.string,
  isActivatBtnDisabled: PropTypes.bool,
  toggleActivateStagePopup: PropTypes.func.isRequired,
  onActivateStageSubmit: PropTypes.func.isRequired,
};

ActiveStagePopUp.defaultProps = {
  extraClass: "",
  caseNumber: "",
  isActivatBtnDisabled: false,
  toggleActivateStagePopup: () => {},
  onActivateStageSubmit: () => {},
};

export default ActiveStagePopUp;
